import { t } from 'i18next'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import StudentRightSideContent from '../../Components/StudentRightSideContent/StudentRightSideContent'
import AdminSideBar from '../../Containers/AdminSideBar'
import { StudentContainer } from '../../Containers/StudentContainer'
import { getAccessProperty } from './../../Service/properties'
import { property } from './../../store/poperty'
import { observer } from 'mobx-react-lite'
import { accept } from '../../store/accept'
import { getAcceprProperties } from '../../Service/accept'
export default observer(function StudentsPage() {
	const getAccessPropties = async id => {
		const result = await getAccessProperty(id)
		property.newAccessProperty(result)
	}
	const getAllTeachers = async () => {
		const data = await getAcceprProperties(0)
		accept.newOknoPropList(data)
	}
	useEffect(() => {
		getAccessPropties(1)
		getAllTeachers()
	}, [])

	return (
		<div className='ContentsWrapper'>
			<Helmet>
				<meta charSet='utf-8' />
				<title>
					{t('st:head.menu')} | {t('st:head.appTitle')}
				</title>
			</Helmet>
			<AdminSideBar />
			<StudentContainer />
			<StudentRightSideContent />
		</div>
	)
})
